// Region abbreviations (lowercased) that should route to a Canadian (.ca)
// sportsbook site instead of the default .com. Add region abbrs here as we
// support more Canadian provinces.
const CANADIAN_REGIONS = new Set(['on']);

export const isCanadianRegion = (region?: string | null): boolean =>
    !!region && CANADIAN_REGIONS.has(region.toLowerCase());

/**
 * Applies a region abbreviation to a book deep link / affiliate URL.
 *
 * Replaces the `ss-state-abbr` placeholder with the region abbreviation, and
 * for Canadian regions swaps the host `.com` TLD for `.ca` (e.g. betmgm.com ->
 * betmgm.ca) so we route to the Canadian sportsbook site.
 */
export const applyRegionToDeepLink = (
    link: string,
    region?: string | null
): string => {
    if (!link) return link;

    let result = link.replace(/ss-state-abbr/g, region || '');

    if (isCanadianRegion(region)) {
        // Only swap the host TLD (`.com` followed by /, ?, # or end of URL),
        // never a `.com` that happens to appear in a path segment.
        result = result.replace(/\.com(?=[/?#]|$)/, '.ca');
    }

    return result;
};
